import React from "react";
import s from "./style.module.css";
import Spotlight from "../../layouts/Spotlight";
import Page from "../../layouts/Page";
import SpotlightsList from "../../components/SpotlightsList";
import FourZeroFour from "../../pages/FourZeroFour";
import { Route, useRouteMatch, Switch } from "react-router-dom";
import spotlightImage from "./Spotlight.svg";

const home = require(`./copy/${process.env.REACT_APP_LANG}/home`);

const SpotlightRoutes = () => {
  let { path } = useRouteMatch();

  const all = home.list.map((key) => {
    const copy = require(`./copy/${process.env.REACT_APP_LANG}/${key}`);

    return {
      path: `${path}/${copy.id}`,
      tag: copy.tag,
      title: copy.title,
      content: copy,
    };
  });

  return (
    <div className={s.wrap}>
      <Switch>
        <Route path={path} exact>
          <Page
            meta={home.meta}
            title={home.title}
            intro={home.intro}
            extraHeaderContent={<img src={`${spotlightImage}`} alt="" />}
          >
            <SpotlightsList items={all} />
          </Page>
        </Route>

        {all.map(({ path, content }) => (
          <Route path={path} key={path}>
            <Spotlight {...content} allSpotlights={all} />
          </Route>
        ))}

        <Route path="*" render={(props) => <FourZeroFour {...props} />} />
      </Switch>
    </div>
  );
};

export default SpotlightRoutes;
